// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_AEvJO","red":"index_red_6r8iA","green":"index_green_XNxG9","price":"index_price_KA0Ck"};